module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "admission"
    }
  }, [_c('h1', {
    staticClass: "title fourtitle"
  }, [_vm._v("錄取名單")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle redcar"
  }, [_vm._v("正取學員")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "admissionList"
  }, _vm._l((_vm.admissionList), function(student, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n        " + _vm._s(student) + "\n      ")])
  }))]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle bluecar"
  }, [_vm._v("備取學員")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "admissionList"
  }, _vm._l((_vm.waiting), function(student, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n        " + _vm._s(student) + "\n      ")])
  }))]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle redcar"
  }, [_vm._v("繳費時間")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "subtitle bluecar"
  }, [_vm._v("中途離營與退費規則")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    staticClass: "subtitle redcar"
  }, [_vm._v("注意事項")]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("即日起至 2017 / 06 / 25 止")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("可選擇之繳費方式包含："), _c('br'), _vm._v("超商代碼/條碼、webATM、ATM轉帳")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("請透過錄取通知中的連結進行第二階段報名後，取得相關繳費資料再繳費。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("如需於 SITCON 夏令營期間中途離營，未滿 20 歲之學員需要由法定監護人簽署暫時 / 提前離營家長同意書；年滿 20 歲之學員需簽署暫時 / 提前離營切結書，旨在保障學員離營期間會注意自身安全，營隊將不負責學員離營後之安全事宜。")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("相關退費規則如下：")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("退費申請日距活動開始前 30 日，實繳金額扣除必要之行政手續費用 200 元後剩餘款項返還。")]), _vm._v(" "), _c('li', [_vm._v("退費申請日距活動開始前 21 - 29 日，扣除實繳金額之 10% 後，剩餘 90% 返還。")]), _vm._v(" "), _c('li', [_vm._v("退費申請日距活動開始前 15 - 20 日，扣除實繳金額之 30% 後，剩餘 70% 返還。")]), _vm._v(" "), _c('li', [_vm._v("退費申請日距活動開始前 8 - 14 日，扣除實繳金額之 50% 後，剩餘 50% 返還。")]), _vm._v(" "), _c('li', [_vm._v("退費申請日距活動開始前 7 日(含）內，不受理退費申請。")]), _vm._v(" "), _c('li', [_vm._v("在營期間若違反 CoC 規範，經 SITCON 夏令營團隊決議由監護人帶離營隊，亦不退還已繳交之報名費用。")]), _vm._v(" "), _c('li', [_vm._v("若因不可抗力之因素，將扣除營服以及相關必要費用，再按照活動參加天數比例扣除報名費用後全數返還。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('ol', [_c('li', [_vm._v("\n        第二階段報名連結已連同錄取通知寄發至前一次報名所留下之電子信箱，請正取學員至您的信箱查閱信件。\n      ")]), _vm._v(" "), _c('li', [_vm._v("請於第二階段報名系統正確選擇您的票種，若票種與報名身份不符（如個人報名卻選擇團體報名），將需透過匯款方式補繳報名費用，否則視將同放棄資格。")]), _vm._v(" "), _c('li', [_vm._v("正取學員資格不得轉讓予他人使用，轉讓者將取消資格。")]), _vm._v(" "), _c('li', [_vm._v("繳費完成始完成報名程序，正取學員若未於期限內繳交報名費用，將取消資格，由備取者遞補。")]), _vm._v(" "), _c('li', [_vm._v("錄取通知以及行前注意等資訊，均將透過報名時所留下之電子郵件通知學員，請務必定期檢查信箱，以確保個人權益。")]), _vm._v(" "), _c('li', [_vm._v("有任何問題歡迎來信至\n        "), _c('a', {
    attrs: {
      "href": "mailto:ask@sitcon.camp"
    }
  }, [_vm._v("ask@sitcon.camp")]), _vm._v("，我們將儘速回覆您。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-284c8d47"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admission.vue
// module id = 84
// module chunks = 0